export default __webpack_public_path__ + "static/media/amal-jagdeesh.64a122e3.jpg";